/**
 * @generated SignedSource<<f7ed19b7bc793d73377626ce12b50162>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type testPageOrderMutation$variables = {
  compositionDocID?: string | null;
  designDocID?: string | null;
};
export type testPageOrderMutation$data = {
  readonly createTestOrder: {
    readonly orderID: number;
  };
};
export type testPageOrderMutation = {
  response: testPageOrderMutation$data;
  variables: testPageOrderMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "compositionDocID"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "designDocID"
},
v2 = [
  {
    "kind": "Variable",
    "name": "compositionDocID",
    "variableName": "compositionDocID"
  },
  {
    "kind": "Variable",
    "name": "designDocID",
    "variableName": "designDocID"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "orderID",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "testPageOrderMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Order",
        "kind": "LinkedField",
        "name": "createTestOrder",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "testPageOrderMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Order",
        "kind": "LinkedField",
        "name": "createTestOrder",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "06e52fe6dbfd5c71e7873ac5a1f40295",
    "id": null,
    "metadata": {},
    "name": "testPageOrderMutation",
    "operationKind": "mutation",
    "text": "mutation testPageOrderMutation(\n  $designDocID: String\n  $compositionDocID: String\n) {\n  createTestOrder(designDocID: $designDocID, compositionDocID: $compositionDocID) {\n    orderID\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "61169e5d22b362008b11214cc2e0379c";

export default node;
